<app-tokenize-form
  #tokenizeForm
  [merchantId]="_merchantId"
  [customerId]="_customerId"
  [formName]="'TerminalForm'"
  [paymentType]="data.paymentType"
  (onValidationChange)="handleTokenizeFormValidationChanged($event)"
  (onTokenized)="handleTokenized($event)"
  (onCancelled)="handleCancelled()"
/>
<!--
        <div style="padding:15px;">
    <app-mastercard-tokenize-form #tokenizeForm [merchantId]="_merchantId" 
        [customerId]="_customerId" 
        (onValidationChange)="handleTokenizeFormValidationChanged($event)" 
        (onTokenized)="handleTokenized($event)" 
        />
    <div style="padding-top:20px;">
        <input type="button" value="Cancel" class="button_primary button_var_2 button_right-spacing" (click)="btnCancel_clicked()" />
        <input type="button" value="Save" class="button_primary button_var_2" (click)="btnSave_clicked()" />
    </div>

</div>
-->
